import {
  Dropdown,
  DropdownOption,
  FormField,
  FormInputGroup,
  FormLabel,
  StandardForm,
  VisuallyHidden,
} from '@vp/swan';
import { useTranslations } from '@vp/om-translations';
import { trackBuyItAgainQuantityChanged } from '../../apis/newrelic/newRelicTrackingApi';
import { useSiteData } from '../../hooks/useSiteData';
import { useBuyItAgainItemContext } from '../contexts/BuyItAgainItemContext';
import { useLineItemData } from '../contexts/LineItemDataContext';
import { useShopperId } from '../../hooks/useShopperId';
import { BUY_IT_AGAIN_SOURCE_PAGE } from '../../constants/sourcePage';

/**
 * Uses item contract from BOP to render a dropdown of quantities for an item on "Buy It Again" page.
 * Sets selectedPricedQuantity shared throughout "Buy It Again" components for a given item.
 */
export const BuyItAgainQuantitySelector = () => {
  const {
    defaultDisplayName,
    pricedQuantities,
    originalOrderedQuantity,
    selectedPricedQuantity,
    setSelectedPricedQuantity,
  } = useBuyItAgainItemContext();
  const shopperId = useShopperId();
  const { vistacartTenant: vistacartTenantName, siteName } = useSiteData();
  const { id: itemId, orderNumber } = useLineItemData();

  const [lineItemMessages = {}] = useTranslations(['lineItemMessages']);

  const handleQuantityChange = (newValue: number) => {
    trackBuyItAgainQuantityChanged({
      sourcePage: BUY_IT_AGAIN_SOURCE_PAGE,
      shopperId,
      siteName,
      orderNumber,
      itemId,
      tenant: vistacartTenantName,
      originalOrderedQuantity,
      newSelectedQuantity: newValue,
    });

    const newSelectedPriceQuantity = pricedQuantities.find(
      (pricedQty) => pricedQty.quantity === newValue
    );
    setSelectedPricedQuantity(newSelectedPriceQuantity);
  };

  return (
    <StandardForm mt={{ xs: 3, sm: 3, md: 4 }}>
      <FormField>
        <FormLabel>
          {lineItemMessages.quantityField}
          <VisuallyHidden>{defaultDisplayName}</VisuallyHidden>
        </FormLabel>
        <FormInputGroup mb={3}>
          <Dropdown
            fullWidth
            onChange={(event) => {
              handleQuantityChange(+event.target.value);
            }}
            value={selectedPricedQuantity?.quantity}
          >
            {pricedQuantities?.map((pricedQty) => (
              <DropdownOption
                value={pricedQty.quantity}
                key={`quantity-${pricedQty.quantity}`}
              >
                {pricedQty.quantity}
              </DropdownOption>
            ))}
          </Dropdown>
        </FormInputGroup>
      </FormField>
    </StandardForm>
  );
};
